import { jsx as _jsx } from "react/jsx-runtime";
var MessageCircle = function MessageCircle(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7 11a1 1 0 1 1 2.001 0 1 1 0 0 1-2 0Zm5-1a1 1 0 1 0 .001 2 1 1 0 0 0 0-2Zm4 0a1 1 0 1 0 .001 2 1 1 0 0 0 0-2Zm3.899 2.294c-.507 3.254-3.13 5.953-6.38 6.562a8.003 8.003 0 0 1-4.616-.487 3.215 3.215 0 0 0-1.253-.262c-.19 0-.378.018-.563.055l-2.812.562.563-2.817c.118-.585.046-1.21-.207-1.81a8.01 8.01 0 0 1-.487-4.617c.609-3.249 3.307-5.872 6.562-6.379 2.59-.403 5.123.413 6.95 2.241 1.83 1.83 2.647 4.363 2.243 6.952Zm-.827-8.366c-2.285-2.284-5.445-3.303-8.674-2.804-4.077.636-7.457 3.92-8.22 7.987a10.008 10.008 0 0 0 .61 5.765c.098.231.128.446.09.64l-.858 4.287a.997.997 0 0 0 .274.903.996.996 0 0 0 .903.274l4.283-.857a1.15 1.15 0 0 1 .643.088 10.02 10.02 0 0 0 5.765.611c4.068-.763 7.352-4.143 7.988-8.22.502-3.227-.52-6.389-2.804-8.674Z",
      fill: color
    })
  });
};
export default MessageCircle;